import React from 'react';
import {useTranslation} from 'react-i18next';
import * as css from './AddLecturerFrame.css';
import PlusThin from '../../../../assets/icons/PlusThin';

interface AddLecturerFrameProps {
    onClick?: () => void;
}

function AddLecturerFrame({onClick}: AddLecturerFrameProps) {
    const {t} = useTranslation('timetable');
    return (
        <css.frame
            type="button"
            onClick={e => { e.stopPropagation(); onClick?.(); }}
            data-cy="add-lecturer-frame"
        >
            <css.content>
                <css.plusBadge><PlusThin /></css.plusBadge>
                <css.label>{t('addNewLecturer')}</css.label>
            </css.content>
        </css.frame>
    );
}

export default AddLecturerFrame;
